import React from "react";
import Image from "next/image";
import Link from "next/link";
import TypographyMontserrat from "../../Atoms/TypographyMontserrat";
import { sendGTMEvent } from "@next/third-parties/google";

const FlyoutContent = ({ links, headerId }) => {
    return (
        <ul className="mt-3 w-full  flex ">
            {links?.map(({ link, text, src }, index) => (
                <li key={index} className="my-3 mx-3">
                    <Link
                        href={link || ""}
                        passHref
                        id={headerId}
                        data-cy={headerId}
                        onClick={() =>
                            sendGTMEvent({
                                event: "NavigationInteractions",
                                menu_name: text,
                                place: "topnavcollectionmenu",
                            })
                        }
                    >
                        <div className="relative w-[302px] h-[178px]">
                            <Image
                                fill
                                src={src}
                                alt={`${text} image`}
                                className="object-cover"
                                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                            />
                        </div>
                        <TypographyMontserrat
                            size={"base"}
                            fontWeight={"medium"}
                            text={text}
                            customStyle={" mt-2 "}
                        />
                    </Link>
                </li>
            ))}
        </ul>
    );
};

export default FlyoutContent;
